// extracted by mini-css-extract-plugin
export default {"list":"UnderwriterList_list__b9I6E","listItem":"UnderwriterList_listItem__lj6k6","listItemSelected":"UnderwriterList_listItemSelected__pbXbv"};